import React from 'react'

import { CodeListHierarchyContainer } from '@/components/containers/codelist-hierarchy/CodeListHierarchyContainer'

const CodeListHierarchyPage: React.FC = () => <CodeListHierarchyContainer />

export default CodeListHierarchyPage
